import { AnyAction, AsyncThunk, combineReducers, configureStore } from '@reduxjs/toolkit';

import areasReducer from './areas/areasSlice';
import authReducer from "./auth/authSlice"
import instructorsReducer from './instructors/instructorsSlice';
import lecturesReducer from "./lectures/lecturesSlice"
import topicsReducer from './topics/topicsSlice';

export { default as useDispatch } from "./utils/useDispatch";
export { default as useSelector } from "./utils/useSelector"

const rootReducer = combineReducers({
  areas: areasReducer,
  instructors: instructorsReducer,
  topics: topicsReducer,
  lectures: lecturesReducer,
  auth: authReducer,
});

const reducer = (state: any, action: AnyAction) => {
  // if (action.type === logout.type) state = {} as ReturnType<typeof rootReducer>;
  return rootReducer(state, action);
};

const store = configureStore({ reducer, devTools: process.env.NODE_ENV !== "production" });

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;

// Since stores are written in JS and I am consuming them in TS they were
// complaining about missing properties, these Generic types fix that
export type GenericThunk = AsyncThunk<{ [args: string]: any }, any, {}>;
export type GenericDispatch = typeof store.dispatch;

export default store;

